module.exports = __webpack_public_path__ + "static/banner-1-5da132b660e3080be55d051f88fe088d.jpg";